var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M443.8 330.8c-3.2 3.5-7.5 5.2-11.8 5.2a15.94 15.94 0 0 1-10.86-4.25L224 149.8 26.9 330.9c-6.5 6-16.64 5.625-22.61-.906-6-6.5-5.594-16.59.89-22.59l208-192a15.956 15.956 0 0 1 21.72 0l208 192c6.4 6.896 6.9 16.896.9 23.396"
  })));
};
export default SvgChevronUp;